import React from 'react'
import styled, { css } from 'styled-components'
import ParseContent from 'components/shared/ParseContent'
import ButtonDefault from 'components/elements/ButtonDefault'
import Plaatjie from '@ubo/plaatjie'
import Img from 'gatsby-image'

const ImgCSS = css`
  height: 100%;
  width: 100%;
  object-fit: cover;
`

const StyledImg = styled(Img)`
  ${ImgCSS};
`

const StyledPlaatjie = styled(Plaatjie)`
  ${ImgCSS};
`

const StyledTextWithImage = styled.section`
  position: relative;
  z-index: 1;
  padding-top: 50px;
  padding-bottom: 50px;

  @media screen and (max-width: 991px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`

const StyledContainer = styled.div`
  height: 100%;

  @media screen and (max-width: 991px) {
    height: unset;
    position: relative;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${({ $textPosition }) =>
    $textPosition === 'right' ? 'row-reverse' : 'row'};
  align-items: center;
  gap: 50px;

  @media screen and (max-width: 991px) {
    flex-direction: column-reverse;
    gap: 30px;
  }
`

const TextColumn = styled.div`
  flex-shrink: 0;

  @media screen and (min-width: 992px) {
    width: 50%;
  }

  & h2 {
    font-weight: ${(props) => props.theme.font.weight.xl};

    @media screen and (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.xl};
    }

    @media screen and (max-width: 991px) {
      font-size: ${(props) => props.theme.font.size.l};
    }
  }
`

const ButtonWrapper = styled.div`
  @media screen and (max-width: 991px) {
    width: 100%;
    & > * {
      width: 100%;
      display: block;
      text-align: center;
    }
  }
`

const ImageColumn = styled.div`
  border-radius: 20px;
  overflow: hidden;

  @media screen and (max-width: 991px) {
    width: 100%;
    max-width: 500px;
    aspect-ratio: 16 / 9;
    align-self: center;
  }

  @media screen and (min-width: 992px) {
    width: 50%;
  }
`

const TextWithImage = ({ className = '', content, textPosition = 'left', id = 'text-with-image' }) => {
  if (!content) return null
  return (
    <StyledTextWithImage id={id} className={`${className}`}>
      <StyledContainer className="container">
        <Wrapper $textPosition={textPosition}>
          <TextColumn>
            <h2>{content?.title}</h2>
            <ParseContent
              className="mt-3"
              content={content?.description}
              compactLineHeight
            />
            <ButtonWrapper>
              <ButtonDefault
                icon="arrow"
                to={content?.link?.url}
                className="mt-3"
              >
                {content?.link?.title}
              </ButtonDefault>
            </ButtonWrapper>
          </TextColumn>
          <ImageColumn>
            {!!content.image?.localFile?.childImageSharp?.fluid ? (
              <StyledImg
                fluid={content.image.localFile.childImageSharp.fluid}
              />
            ) : (
              <StyledPlaatjie image={content.image} />
            )}
          </ImageColumn>
        </Wrapper>
      </StyledContainer>
    </StyledTextWithImage>
  )
}

export default TextWithImage
